var path = 'api/Portal/Inbox'

const OperationEnum = {
    Verification: 1,
    CertificateOrder: 2
}

const SubOperationEnum = {
    ResponseContact: 1
}

function getMail (http) {
    return http.post(path + 'GetMail')
}

function getMailById (http, id) {
    return http.post(path + 'GetMailById?MailId=' + id, { mailId: id })
}

function GetMailByRequestId (http, id) {
    return http.post(path + 'GetMailByRequestId?RequestId=' + id, { requestId: id })
}

function sendMail (http, dto) {
    return http.post(path + 'SendMail', dto)
}

function mailDetails (http, id) {
    return http.post(path + 'MailDetails?MailId=' + id, { mailId: id })
}

function printAbstract (http, id) {
    return http.post(path + 'PrintAbstract?RequestId=' + id, { requestId: id }, { responseType: 'arraybuffer' })
}

function printAffidavit (http, id) {
    return http.post(path + 'PrintAffidavit?RequestId=' + id, { requestId: id }, { responseType: 'arraybuffer' })
}

function acknowledgeMail (http, id) {
    return http.post(path + 'MailAcknowledge?MailId=' + id, { mailId: id })
}

export default {
    OperationEnum: OperationEnum,
    SubOperationEnum: SubOperationEnum,
    getMail: getMail,
    GetMailByRequestId: GetMailByRequestId,
    printAbstract: printAbstract,
    sendMail: sendMail,
    mailDetails: mailDetails,
    acknowledgeMail: acknowledgeMail,
    getMailById: getMailById,
    printAffidavit: printAffidavit
}
